// StepThree.js
import React, { useEffect, useState } from "react";
import { Form, Button, Image, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValuesThree, validationSchemaThree } from "./StepThree.form";
import { SceneFormFile } from "./SceneFormFile";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./SceneForm.scss";
import { TiptapEditor } from "../../../TiptapEditor/TiptapEditor";

const virtualSceneController = new VirtualScenes();

export function StepThree({
  formData,
  updateFormData,
  nextStep,
  prevStep,
  isUpdateMode,
  scene,
}) {
  const { accessToken } = useAuth();
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [isPublic, setIsPublic] = useState(true);
  const [fileFieldName, setFileFieldName] = useState("");
  const [moduleData, setModuleData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState({
    bannertop: isUpdateMode
      ? moduleData?.bannertop
      : formData.bannertop || null,
  });
  //console.log(scene); // Log for debugging
  //console.log("isUpdateMode", isUpdateMode);

  // Cargar los datos del módulo si estamos en modo de actualización
  // Cargar los datos del módulo si estamos en modo de actualización
  useEffect(() => {
    async function fetchData() {
      if (isUpdateMode) {
        try {
          const data = await virtualSceneController.getVirtualScenesModeule(
            scene.refId,
            accessToken,
            "module_03",
          );
          setModuleData(data.moduleData); // Suponiendo que 'data' ya contiene los campos correctos
          //console.log("module", data.moduleData);
          //console.log("category", data.moduleData.category);
        } catch (error) {
          console.error("Error fetching module data:", error);
        }
      }
    }
    fetchData();
  }, [isUpdateMode, accessToken, scene.refId]);

  const handleFileSubmit = (fileData) => {
    const { id } = fileData;
    // For multiple files
    setUploadedFiles((prev) => ({
      ...prev,
      [fileFieldName]: prev[fileFieldName]
        ? [...prev[fileFieldName], fileData]
        : [fileData],
    }));
    formik.setFieldValue(fileFieldName, [...formik.values[fileFieldName], id]);
  };

  const handleRemoveFile = async (fieldName, index) => {
    let fileId;
    if (uploadedFiles[fieldName] && uploadedFiles[fieldName][index]) {
      fileId = uploadedFiles[fieldName][index]._id; // Correctly access the file ID by index
      //console.log("fileId", fileId); // Debugging line to verify the ID

      try {
        await virtualSceneController.deleteImageRepo(accessToken, fileId); // Use the correct ID
        setUploadedFiles((prev) => ({
          ...prev,
          [fieldName]: prev[fieldName].filter((_, i) => i !== index), // Remove the file from the array
        }));
        formik.setFieldValue(
          fieldName,
          formik.values[fieldName].filter((_, i) => i !== index),
        ); // Update formik values
      } catch (error) {
        console.error("Error al eliminar el archivo:", error);
      }
    }
  };
  const formik = useFormik({
    initialValues: isUpdateMode
      ? initialValuesThree(moduleData)
      : initialValuesThree(formData),
    validationSchema: validationSchemaThree(),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        let _id = "";
        if (isUpdateMode) {
          _id = scene.refId;
        } else {
          _id = localStorage.getItem("idScene");
        }

        // Handle tagsInput before updating formData
        if (values.tagsInput) {
          values.tags = [...values.tags, values.tagsInput.trim()];
          values.tagsInput = "";
        }
        //compruebo que el local storage este vacio o null para no guardar un idScene que no corresponda
        const modulePath = "module_03";
        const respone = await virtualSceneController.createModuleAdd(
          modulePath,
          accessToken,
          _id,
          values,
        );
        console.log("response", respone);
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }

      updateFormData({ ...values, ...uploadedFiles });
      nextStep();
    },
  });
  useEffect(() => {
    // Si existe imagenes, obtenemos los datos del archivo
    if (
      moduleData?.ModThreeImagesObjetives &&
      Array.isArray(moduleData.ModThreeImagesObjetives)
    ) {
      async function fetchFiles() {
        try {
          const filePromises = moduleData.ModThreeImagesObjetives.map(
            (fileId) => virtualSceneController.getFileScene(fileId),
          );
          const fileDataArray = await Promise.all(filePromises);
          setUploadedFiles((prev) => ({
            ...prev,
            ModThreeImagesObjetives: fileDataArray,
          }));
        } catch (error) {
          console.error("Error al obtener los datos de las imágenes:", error);
        }
      }

      fetchFiles();
    }
  }, [moduleData?.ModThreeImagesObjetives]);

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Title */}
      <Form.Field>
        <label>Título del desarrollo</label>
        <Form.Input
          name="ModThreeTitle"
          placeholder="Ingrese el título"
          onChange={formik.handleChange}
          value={formik.values.ModThreeTitle}
          error={formik.errors.ModThreeTitle}
        />
      </Form.Field>

      {/* Desarrollo 1 (500 palabras máximo) */}
      <label className="field-label">Desarrollo 1 (500 palabras máximo)</label>
      <TiptapEditor
        content={formik.values.ModThreeContent}
        onChange={(content) => formik.setFieldValue("ModThreeContent", content)}
      />

      {/* Imágenes Sala */}
      <Form.Field>
        <label>Imágenes de la Sala</label>
        <Button
          type="button"
          onClick={() => {
            setIsPublic(true);
            setFileFieldName("ModThreeImagesObjetives");
            setIsFileModalOpen(true);
          }}
        >
          Subir Imágenes
        </Button>
        <div className="images-preview">
          {(uploadedFiles.ModThreeImagesObjetives || []).map((file, index) => (
            <div key={index} className="image-item">
              <Image src={file.url} size="small" />
              <Icon
                name="close"
                onClick={() =>
                  handleRemoveFile("ModThreeImagesObjetives", index)
                }
              />
            </div>
          ))}
        </div>
      </Form.Field>

      {/* Modal for File Upload */}
      <SceneFormFile
        isOpen={isFileModalOpen}
        onClose={() => setIsFileModalOpen(false)}
        onSubmit={handleFileSubmit}
        isPublic={isPublic}
        idScene={formik.values.idScene}
      />

      {/* Desarrollo 2 (500 palabras máximo) */}
      <label className="field-label">Desarrollo 2 (500 palabras máximo)</label>
      <TiptapEditor
        content={formik.values.ModThreeSubcontent}
        onChange={(content) =>
          formik.setFieldValue("ModThreeSubcontent", content)
        }
      />

      <Form.Group>
        <Button
          type="button"
          onClick={prevStep}
          color="orange"
          style={{ width: "33.3333%" }}
        >
          Anterior
        </Button>
        <Button
          type="submit"
          primary
          style={{
            width: isUpdateMode ? "33.3333%" : "66.6666%",
            marginLeft: isUpdateMode ? "auto" : "33.3333%",
          }}
          loading={formik.isSubmitting}
        >
          Subir
        </Button>
        {isUpdateMode && (
          <Button
            type="button"
            onClick={nextStep}
            color="green"
            style={{ width: "33.3333%" }}
          >
            Siguiente
          </Button>
        )}
      </Form.Group>
    </Form>
  );
}
